import { PHONE_NUMBER_STATUS } from 'src/types/phoneNumberStatus'
import { User } from 'src/types/user'

// 電話番号の認証が必要な場合はtrueを返す。それ以外は不要。
export const needPhoneNumberVerification = (user: User): boolean => {
  return user.phoneNumberStatus === PHONE_NUMBER_STATUS['UNVERIFIED']
}
